import { Typography } from '@material-ui/core';
import DataType from '@opsbase/lib-datatype/DataType';
import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import useOpDefinitionCopy from '@opsbase/react-gql-hooks/opdefinition/useOpDefinitionCopy';
import useSelection from '@opsbase/web-data-selection/useSelection';
import useSelectionActions from '@opsbase/web-data-selection/useSelectionActions';
import ConfirmDialog from '@opsbase/web-dialogs/ConfirmDialog';
import useParams from '@opsbase/web-nav/useParams';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import Checkbox from '@opsbase/web-ui/Checkbox/Checkbox';
import React, { useCallback, useMemo, useState } from 'react';
export function OpDefinitionCopyDialog() {
    const { id } = useParams();
    const dataType = DataType.OPDEFINITION;
    const { selecteds } = useSelection(dataType);
    const { clearSelection } = useSelectionActions(dataType);
    const { raise } = useNotificationActions();
    const [shouldCopyBusinessRules, setShouldCopyBusinessRules] = useState(false);
    const copyOpDefinitions = useOpDefinitionCopy();
    const ids = useMemo(() => (id === 'selected' ? selecteds.map(o => o.id) : [id]), [id, selecteds]);
    const copyText = i18n.t('copy');
    const cancelText = i18n.t('cancel');
    const text = i18n.t('confirm-opdefinition-copy', { count: ids.length });
    const handleAction = useCallback(async () => {
        clearSelection();
        return raise(copyOpDefinitions({ ids, shouldCopyBusinessRules }), i18n.t('opdefinition-copy-successful'));
    }, [clearSelection, copyOpDefinitions, ids, raise, shouldCopyBusinessRules]);
    return (React.createElement(ConfirmDialog, { onConfirm: handleAction, agreeText: copyText, notAgreeText: cancelText, color: Palette.positive },
        React.createElement(Typography, null, text),
        React.createElement("br", null),
        React.createElement(Checkbox, { label: i18n.t('copy-business-rules'), checked: shouldCopyBusinessRules, onChange: setShouldCopyBusinessRules })));
}
export default OpDefinitionCopyDialog;
